import Swal from 'sweetalert2';

/** Merkevare: blå (#005379), svart, hvit — matcher `main.scss` $techblue */
const adaDefaults = {
	background: '#ffffff',
	color: '#000000',
	confirmButtonColor: '#005379',
	cancelButtonColor: '#000000',
	denyButtonColor: '#000000',
	buttonsStyling: true,
};

/**
 * SweetAlert2 med ADA-standardfarger. Bruk i stedet for `alert()`.
 * @param {import('sweetalert2').SweetAlertOptions} options
 */
export function adaSwal(options) {
	return Swal.fire({ ...adaDefaults, ...options });
}

/** Enkel tekst-/tittel-dialog med én OK-knapp */
export function adaAlert(text, title = '') {
	return adaSwal({
		title: title || undefined,
		text,
		confirmButtonText: 'OK',
	});

}
